export default {
  name: 'ReportDownloadHistory',
}


// WEBPACK FOOTER //
// ./src/user_center/js/ReportDownloadHistory.js